import React from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import MainTitle from "../../../components/ui/MainTitle";
import SubmitButton from "../../../components/form/SubmitButton";
import LoadingButton from "../../../components/form/LoadingButton";
import { useTranslation } from "react-i18next";
import { useUpdateResource } from "../../../hooks/useUpdateResource";
import TicketForm from "./TicketForm";

export interface TicketFormData {
  title: string;
  description:string
}

export default function CreateTicketPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { loading, updateResource } = useUpdateResource();

  const { register, handleSubmit, formState: { errors } } = useForm<TicketFormData>({
    defaultValues: { title: "" },
  });

  const onSubmit: SubmitHandler<TicketFormData> = (data) => {
    updateResource("ticket", {subject:data.title,description:data.description}, "store", {
      method: "POST",
      successMessage: t("createdSuccess"),
      invalidateQueries:["store-tickets"],
      navigateAfter: () => navigate("/store/tickets"),
    });
  };

  return (
    <div className="p-6 container">
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4 w-full">
        <MainTitle title={t("add_new_ticket")} />
        <TicketForm register={register} errors={errors} />

        {loading ? (
          <LoadingButton height={64} />
        ) : (
          <SubmitButton height={64} label="create" />
        )}
      </form>
    </div>
  );
}
